var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAremxyMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95391 32C3.79891 32 2.80981 31.608 1.98661 30.824C1.16341 30.04 0.75251 29.0987 0.75391 28V4C0.75391 2.9 1.16551 1.958 1.98871 1.174C2.81191 0.390003 3.80031 -0.00132994 4.95391 3.39559e-06H38.5539C39.7089 3.39559e-06 40.698 0.392003 41.5212 1.176C42.3444 1.96 42.7553 2.90134 42.7539 4V28C42.7539 29.1 42.3423 30.042 41.5191 30.826C40.6959 31.61 39.7075 32.0013 38.5539 32H4.95391ZM21.7539 18L38.5539 8V4L21.7539 14L4.95391 4V8L21.7539 18Z",
    fill: "#CDD1E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAremxyMail);
export default __webpack_public_path__ + "static/media/aremxy_mail.703a755faae7a3fed6a2da237ae08fc0.svg";
export { ForwardRef as ReactComponent };